import React, { useState, useEffect, useRef } from "react";
import { CgCloseR } from "react-icons/cg";
import { formattedDate } from "../../utils/dateUtils";
import { GrStatusInfo } from "react-icons/gr";
import { useSelector } from "react-redux";
import Loading from "../../component/Loading/Loading";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { AiOutlineSortAscending } from "react-icons/ai";
import Pagination from "../../utils/Pagenation/Pagenation";
import useAxiosInstance from "../../services/useAxiosInstance";
import DeletePopup from "../../utils/DeletePopup/DeletePopup";
import { Plus, Eye, Search, Calendar, Clock } from "lucide-react";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const AmenityBooking = () => {
    const axiosInstance = useAxiosInstance();
    const [clearBtnshow, setClearBtnshow] = useState(false);
    const [showCommunityForm, setShowCommunityForm] = useState(false);
    const [viewCommunityForm, setViewCommunityForm] = useState(false);
    const currentDate = new Date().toISOString().split("T")[0];
    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);
    const clientId = useSelector((state) => state.auth.clientId);
    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
    const token = useSelector((state) => state.auth.token);
    const getStatusColor = (status) => {
        switch (status) {
            case "BOOKING_CANCELLED":
                return "#676765";
            case "BOOKING_REQUEST":
                return "#165E3D";
            case "BOOKING_IN_PROGRESS":
                return "#B5850B";
            case "BOOKING_APPROVED":
                return "#165E3D";
            default:
                return "#000000";
        }
    };

    const [amenityBookings, setAmenityBookings] = useState([]);
    const communityIds = useSelector((state) => state.auth.communityId);
    const userIds = useSelector((state) => state.auth.userId);
    const roleId = useSelector((state) => state.auth.roleId);
    const clinetId = useSelector((state) => state.auth.clientId);

    const communityIdget = communityIds;

    let createdByIdget;
    if (roleId === 1001 || roleId === 1002) {
        createdByIdget = 0;
    } else if (roleId === 1003) {
        createdByIdget = clientId;
    }

    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        const fetchbookingStatus = async () => {
            try {
                const responseStatuses = await axiosInstance.get(
                    `/api/public/amenityBookingStatus/getAll`
                );
                setStatuses(responseStatuses.data);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchbookingStatus();
    }, []);

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getNextSeventhDate = () => {
        const today = new Date();
        const nextSeventhDate = new Date(today);
        nextSeventhDate.setDate(today.getDate() + 7);
        return nextSeventhDate.toISOString().split('T')[0];
    };

    const [startDate, setStartDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState(getNextSeventhDate());
    const [amenityBookingStatusIds, setAmenityBookingStatusIds] = useState(0);

    const fetchAmenityBookingData = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/api/public/amenitybooking/CommunityIdAndCreatedById`, {
                params: {
                    bookedForClientId: createdByIdget,
                    communityId: communityIdget,
                    endDate: endDate,
                    startDate: startDate,
                    amenityBookingStatusId: amenityBookingStatusIds,
                },
                timeout: 10000,
            });

            setAmenityBookings(response.data);
            console.log(response.data);
        } catch (error) {
            if (error.response) {
                console.error("API error:", error.response.data);
            } else if (error.request) {
                console.error("Network error:", error.request);
            } else {
                console.error("Error", error.message);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAmenityBookingData();
    }, [communityIdget, createdByIdget, startDate, endDate, amenityBookingStatusIds, token]);

    const [filterData, setFilterData] = useState({
        startDates: getTodayDate(),
        endDates: getNextSeventhDate(),
        amenityBookingStatusIdss: 0
    });

    const handleStartDateChange = (event) => {
        const newStartDate = event.target.value;
        setFilterData(prev => ({
            ...prev,
            startDates: newStartDate,
            endDates: (prev.endDates && newStartDate > prev.endDates) ? '' : prev.endDates
        }));
    };

    const handleEndDateChange = (event) => {
        setFilterData({
            ...filterData,
            endDates: event.target.value
        });
    };

    const handleBookingStatusChange = (event) => {
        setFilterData({
            ...filterData,
            amenityBookingStatusIdss: event.target.value
        });
    };

    const handleSearch = () => {
        setStartDate(filterData.startDates);
        setEndDate(filterData.endDates);
        setAmenityBookingStatusIds(filterData.amenityBookingStatusIdss);
        setCurrentPage(0);
        setClearBtnshow(true);
    };

    const clearFilters = () => {
        setStartDate(getTodayDate());
        setEndDate(getNextSeventhDate());
        setAmenityBookingStatusIds(0);
        setSearchName('');
        setFilterData({
            startDates: getTodayDate(),
            endDates: getNextSeventhDate(),
            amenityBookingStatusIds: 0
        })
        setClearBtnshow(false);
    };

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;

    const [clients, setClients] = useState([]);

    useEffect(() => {
        if (!communityId) return;

        const fetchClients = async () => {
            try {
                const response = await axiosInstance.get(`/api/user/getUsersList/${communityId}`);
                if (response.status === 200) {
                    const activeUsers = response.data.filter(user => user.activeStatus === true || user.activeStatus === "true");
                    console.log(response.data);
                    console.log("Filtered active users:", activeUsers);
                    setClients(activeUsers);
                } else {
                    throw new Error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error("Error fetching clients:", error);
            }
        };

        fetchClients();
    }, [communityId]);

    const initialFormData = {
        amenityBookingDTO: {
            amenityBookingId: 0,
            amenityTypeId: 0,
            amenityId: 0,
            amenityBookingStatusId: 1,
            amount: 0,
            bookedForClientId: roleId === 1003 ? clinetId : 0,
            bookedUserId: userId,
            bookingDate: new Date().toISOString(),
            bookingStart: "",
            bookingEnd: "",
            communityId: communityId,
            createdById: userId,
            createdDate: new Date().toISOString(),
            modifiedById: null,
            modifiedDate: new Date().toISOString(),
            remarks: "",
        },
        amenitySlots: [],
    };

    const [formData, setFormData] = useState({
        amenityBookingDTO: {
            amenityBookingId: 0,
            amenityId: 0,
            amenityTypeId: 0,
            amount: 0,
            bookedForClientId: roleId === 1003 ? clinetId : 0,
            bookedUserId: userId,
            bookingDate: new Date().toISOString(),
            bookingStart: "",
            bookingEnd: "",
            communityId: communityId,
            createdById: userId,
            createdDate: new Date().toISOString(),
            modifiedById: null,
            amenityBookingStatusId: 1,
            modifiedDate: new Date().toISOString(),
            remarks: "hello",
        },
        amenitySlots: [0],
    });
    const [errors, setErrors] = useState({});

    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (name === "amenityBookingDTO.amenityTypeId") {
            setAmenityTypeIds(value);
        }

        if (name === "amenityBookingDTO.amenityId") {
            setAmenityIds(value);
        }
        if (name === "amenityBookingDTO.bookingStart") {
            try {
                await handleAvailableSlots(amenityIds, value);
            } catch (error) {
                console.error('Error fetching available slots:', error);
            }
        }
        const intFields = [
            'amenityBookingDTO.amenityId',
            'amenityBookingDTO.amenityTypeId',
            'amenityBookingDTO.amount',
            'amenityBookingDTO.bookedForClientId',
            'amenityBookingDTO.bookedUserId',
            'amenityBookingDTO.communityId',
            'amenityBookingDTO.createdById',
            'amenitySlots'
        ];
        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData };

            if (name.startsWith('amenityBookingDTO.')) {
                const key = name.split('.')[1];
                if (key === 'bookingStart') {
                    const formattedDate = new Date(value).toISOString();
                    updatedFormData.amenityBookingDTO.bookingStart = formattedDate;
                    updatedFormData.amenityBookingDTO.bookingEnd = formattedDate;
                } else {
                    updatedFormData.amenityBookingDTO[key] = intFields.includes(name) ? parseInt(value, 10) : value;
                }
            } else if (name === 'amenitySlots') {
                updatedFormData.amenitySlots = [parseInt(value, 10)];
            } else {
                updatedFormData[name] = value;
            }

            return updatedFormData;
        });
    };

    const validate = () => {
        const newErrors = {};
        if (roleId !== 1003 && !formData.amenityBookingDTO.bookedForClientId) {
            newErrors.bookedForClientId = 'Client Name is required';
        }
        if (!formData.amenityBookingDTO.bookingStart) {
            newErrors.bookingStart = 'Booked For Date is required';
        }
        if (!formData.amenityBookingDTO.amenityTypeId) {
            newErrors.amenityTypeId = 'Amenity Type is required';
        }
        if (!formData.amenityBookingDTO.amenityId) {
            newErrors.amenityId = 'Amenity is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const newErrors = {};
        if (!validate()) {
            return;
        }

        if (Object.keys(newErrors).length === 0) {
            console.log(formData);
            setShowCommunityForm(false);
            setLoading(true);
            axiosInstance
                .post(`/api/public/amenitybooking/add`, formData,)
                .then((response) => {
                    console.log("Booking successful:", response.data);
                    setAlert({ visible: true, message: 'Amenity Booking successfully!', type: 'success' });

                    fetchAmenityBookingData();
                    setFormData(initialFormData);
                    setAmenities([]);
                    setSlots([]);
                    setErrors({});
                    setLoading(false);
                    setShowCommunityForm(false);
                })
                .catch((error) => {
                    console.error("Error booking amenity:", error);
                    setAlert({ visible: true, message: 'Error booking amenity. Please try again.', type: 'error' });
                    setLoading(false);
                });
        } else {
            setErrors(newErrors);
            setLoading(false);
        }
    };

    const handleAddcommunityClick = () => {
        setShowCommunityForm(!showCommunityForm);
        setFormData(initialFormData);
        setAmenities([]);
        setSlots([]);
        setErrors({});
    };

    const handleCancelClick = (e) => {
        if (e) e.preventDefault();
        setFormData(initialFormData);
        setAmenities([]);
        setSlots([]);
        setErrors({});
        setShowCommunityForm(false);
        setViewCommunityForm(false);
    };

    const [amenityTypes, setAmenityTypes] = useState([]);
    console.log(communityId);

    const [amenities, setAmenities] = useState([]);
    console.log(amenities);

    useEffect(() => {
        const fetchAmenityTypes = async () => {
            try {
                const response = await axiosInstance.get(`/api/public/amenitytype/findByCommunityId/${communityId}`);

                if (response.data && Array.isArray(response.data)) {
                    const activeAmenities = response.data.filter(
                        (amenity) => amenity.activeStatus === true
                    );
                    setAmenityTypes(activeAmenities);
                }
            } catch (error) {
                console.error("Error fetching amenity types:", error);
            }
        };

        fetchAmenityTypes();
    }, [communityId]);

    const [amenityTypeIds, setAmenityTypeIds] = useState(null);
    const [amenityIds, setAmenityIds] = useState(null);

    useEffect(() => {
        const fetchAmenities = async () => {
            try {
                setLoading(true); // Show loading state
                const response = await axiosInstance.get(`/api/public/amenity/getByAmenityTypeId/${amenityTypeIds}`);

                if (response.data && Array.isArray(response.data)) {
                    // Filter active amenities (checking both boolean true and string "true")
                    const activeAmenities = response.data.filter(
                        amenity => amenity.activeStatus === true || amenity.activeStatus === "true"
                    );

                    setAmenities(activeAmenities);
                    console.log("Fetched amenities:", activeAmenities);
                }
            } catch (error) {
                console.error("Error fetching amenities:", error);
                setAlert({
                    visible: true,
                    message: "Failed to fetch amenities",
                    type: "error"
                });
            } finally {
                setLoading(false); // Hide loading state
            }
        };

        if (amenityTypeIds) {
            fetchAmenities();
        } else {
            // Clear amenities if no amenityTypeIds is selected
            setAmenities([]);
        }
    }, [amenityTypeIds]);

    useEffect(() => {
        const fetchAmenitySlots = async () => {
            try {
                const response = await axiosInstance.get(
                    `/api/public/amenityslot/findAmenitySlotByAmenityId/${amenityIds}`);
                if (response.data && Array.isArray(response.data)) {
                }
            } catch (error) {
                console.error("Error fetching slots:", error);
            }
        };

        const fetchAmenityAmount = async () => {
            try {
                const response = await axiosInstance.get(`/api/public/amenity/amount/${amenityIds}`);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    amenityBookingDTO: {
                        ...prevFormData.amenityBookingDTO,
                        amount: response.data,
                    },
                }));
            } catch (error) {
                console.error("Error fetching amount:", error);
            }
        };

        if (amenityIds) {
            fetchAmenitySlots();
            fetchAmenityAmount();
        }
    }, [amenityIds, userId, communityId]);

    const [slots, setSlots] = useState([]);
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedBookingId, setSelectedBookingId] = useState(0);

    const [activeStatusSet, setActiveStatusSet] = useState(true);

    const [paymentFormData, setPaymentFormData] = useState({
        amenityBookingId: 0,
        amount: 0,
        clientId: 0,
        communityId: 0,
        createdById: userId,
        createdDate: new Date().toISOString(),
        isApproved: true,
        modifiedById: null,
        modifiedDate: new Date().toISOString(),
        monthlyRevenueId: null,
        paymentBank: "",
        paymentDate: "",
        paymentDetailId: null,
        paymentMethod: "",
        paymentStatus: "",
        paymentType: "",
        reason: "Amenity Booking ",
        serviceRequestId: null,
        violationId: null
    });

    const handleUpdateStatus = async (statusId) => {
        console.log(statusId);
        console.log("1");
        setShowApprovalModal(false);
        setLoading(true);

        try {
            const response = await axiosInstance.patch(`/api/public/amenitybooking/updateAmenityBookingStatus/${selectedBookingId}`,
                null,
                {
                    params: { amenityBookingStatusId: statusId }
                }
            );

            console.log(response.data);

            if (response.status === 200) {
                console.log('start-pay');

                setAlert({
                    visible: true,
                    message: 'Booking status updated successfully!',
                    type: 'success'
                });

                if (response.data.amenityBookingStatusId === 2) {
                    console.log('start-pay1');

                    const updatedPaymentFormData = {
                        ...paymentFormData,
                        amenityBookingId: response.data.amenityBookingId,
                        amount: response.data.amount,
                        clientId: response.data.bookedForClientId,
                        communityId: response.data.communityId,
                    };

                    console.log('ok', updatedPaymentFormData);

                    const paymentResponse = await axiosInstance.post(`/api/public/paymentdetail/add`, updatedPaymentFormData,);

                    if (paymentResponse.status === 201) {
                        console.log('Payment added successfully');
                    } else {
                        console.log('Payment addition failed');
                    }
                }
            }
            fetchAmenityBookingData();
        } catch (error) {
            console.error("Error updating booking status or adding payment details:", error.response?.data || error.message);
            setAlert({
                visible: true,
                message: `Error updating booking status or adding payment details. ${error.response?.data?.message || 'Please try again.'}`,
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    const openApprovalModal = (userId, bookingId, activeStatusSet) => {
        setShowApprovalModal(true);
        setSelectedUserId(userId);
        setSelectedBookingId(bookingId);
        setActiveStatusSet(activeStatusSet);
    };

    const closeModal = () => {
        setShowApprovalModal(false);
    };

    const [viewData, setViewData] = useState({});

    const handleEditClick = async (bookingId) => {
        console.log(bookingId);

        try {
            const response = await axiosInstance.get(
                `/api/public/amenitybooking/getOne/AmenityBookingSlots/${bookingId}`
            );

            const data = response.data; // Change this line - use response.data instead of response.json()
            console.log(response);

            setViewData(data);
            setSelectedBookingId(data.amenityBookingId);
            console.log(data.amenityName);
            console.log(data.amenityBookingStatusName);
            console.log(data.amenityBookingId);

            setViewCommunityForm(true);
        } catch (error) {
            console.error("Error fetching booking details:", error);
        }
    };

    const [searchName, setSearchName] = useState("");
    const handleSearchChange = (event) => {
        setSearchName(event.target.value);
        setCurrentPage(0);
        setClearBtnshow(true);
    };

    const [sortColumn, setSortColumn] = useState('amenityName');
    const [sortOrder, setSortOrder] = useState('asc');

    const handleSort = (column) => {
        const newSortOrder = (column === sortColumn && sortOrder === 'asc') ? 'desc' : 'asc';
        setSortColumn(column);
        setSortOrder(newSortOrder);
    };

    const sortedData = [...amenityBookings].sort((a, b) => {
        const aValue = a[sortColumn];
        const bValue = b[sortColumn];

        if (typeof aValue === 'string') {
            return sortOrder === 'asc'
                ? aValue.localeCompare(bValue, undefined, { sensitivity: 'base' })
                : bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
        }

        return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    });

    const searchQuery = searchName.toLowerCase();

    const filteredData = sortedData.filter((item) => {
        return (
            item.amenityName.toLowerCase().includes(searchQuery) ||
            item.bookedClientName.toLowerCase().includes(searchQuery) ||
            item.bookedClientAddress.toLowerCase().includes(searchQuery)
        );
    });

    const uniqueFilteredData = filteredData.filter((value, index, self) =>
        index === self.findIndex((t) => t.amenityBookingId === value.amenityBookingId)
    );

    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const mergedFilteredData = filteredData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const handleAvailableSlots = async (amenityId, bookingStart) => {
        try {
            const response = await axiosInstance.get(`/api/public/amenitybooking/availableSlots/${amenityId}`, {
                params: {
                    bookingStart: bookingStart,
                }
            });
            setSlots(response.data);
        } catch (error) {
            console.error('Error fetching available slots:', error);
            throw error;
        }
    };

    // Modal footers
    const bookingModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                type="button"
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={handleCancelClick}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleSubmit}
            >
                Submit
            </button>
        </div>
    );

    const viewModalFooter = (
        <div className="flex justify-end">
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleCancelClick}
            >
                Close
            </button>
        </div>
    );

    const approvalModalFooter = (
        <div className="flex justify-end">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
        </div>
    );

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Amenity Booking</h1>
                        <div className="flex items-center">
                            <button
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                onClick={handleAddcommunityClick}
                            >
                                <Plus size={18} />
                                <span>Add</span>
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="p-4 border-b border-gray-200">
                            <div className="flex flex-col md:flex-row justify-between gap-4">
                                <div className="flex items-center">
                                    <div className="relative w-full md:w-64">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                            <Search className="h-5 w-5 text-gray-400" />
                                        </div>
                                        <input
                                            type="text"
                                            id="searchName"
                                            value={searchName}
                                            onChange={handleSearchChange}
                                            placeholder="Search by Amenity"
                                            className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
                                    <div className="flex flex-row gap-1 w-full md:w-auto">
                                        <div className="relative w-1/2 md:w-auto">
                                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                <Calendar className="h-4 w-4 text-gray-400" />
                                            </div>
                                            <input
                                                type="date"
                                                name="startDates"
                                                value={filterData.startDates}
                                                onChange={handleStartDateChange}
                                                max={filterData.endDates || ''}
                                                className="pl-10 pr-2 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                            />
                                        </div>
                                        <div className="relative w-1/2 md:w-auto">
                                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                <Calendar className="h-4 w-4 text-gray-400" />
                                            </div>
                                            <input
                                                type="date"
                                                name="endDates"
                                                value={filterData.endDates}
                                                onChange={handleEndDateChange}
                                                min={filterData.startDates || new Date().toISOString().split('T')[0]}
                                                className="pl-10 pr-2 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                            />
                                        </div>
                                    </div>

                                    <select
                                        name="amenityBookingStatusIdss"
                                        id="amenityBookingStatusIdss"
                                        value={filterData.amenityBookingStatusIdss}
                                        onChange={handleBookingStatusChange}
                                        className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-auto"
                                    >
                                        <option value="">Select Status</option>
                                        {statuses.map((status) => (
                                            <option
                                                key={status.amenityBookingStatusId}
                                                value={status.amenityBookingStatusId}
                                            >
                                                {status.amenityBookingStatusName}
                                            </option>
                                        ))}
                                    </select>

                                    <button
                                        onClick={handleSearch}
                                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 w-full md:w-auto"
                                    >
                                        Search
                                    </button>

                                    {clearBtnshow && (
                                        <button
                                            onClick={clearFilters}
                                            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 w-full md:w-auto"
                                            title="Clear Filter"
                                        >
                                            Clear
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th
                                            className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider cursor-pointer"
                                            onClick={() => handleSort('bookedClientName')}
                                        >
                                            Client Name <AiOutlineSortAscending className="inline ml-1" />
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Client Address</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amenity</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amenity Type</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Booking Start</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Payment Amount</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Status</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {mergedFilteredData.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                        </tr>
                                    ) : (
                                        mergedFilteredData.map((item) => (
                                            <tr key={item.amenityBookingId} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.bookedClientName}</td>
                                                <td className="px-6 py-4 text-sm text-gray-900">
                                                    {item.bookedClientAddress
                                                        ?.match(/.{1,20}/g) // splits the string into chunks of 1 to 20 characters
                                                        .map((line, index) => (
                                                            <div key={index}>{line}</div>
                                                        ))}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.amenityName}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.amenityTypeName}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    {formattedDate(item.bookingStart)}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">{item.amount.toFixed(2)}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
                                                        style={{
                                                            color: getStatusColor(item.amenityBookingStatusName),
                                                            backgroundColor: `${getStatusColor(item.amenityBookingStatusName)}10`
                                                        }}>
                                                        {item.amenityBookingStatusName}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                    <div className="flex items-center gap-2">
                                                        {item.bookingStatus !== "BOOKING_CANCELLED" && (
                                                            <button
                                                                className="text-gray-500 hover:text-gray-700"
                                                                onClick={() => openApprovalModal(
                                                                    item.bookedForClientId,
                                                                    item.amenityBookingId,
                                                                    item.activeStatusSet
                                                                )}
                                                                title="Manage Status"
                                                            >
                                                                <GrStatusInfo size={18} />
                                                            </button>
                                                        )}
                                                        <button
                                                            className="text-blue-500 hover:text-blue-700"
                                                            onClick={() => handleEditClick(item.amenityBookingId)}
                                                            title="View Details"
                                                        >
                                                            <Eye size={18} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Page {currentPage + 1} of {pageCount}
                            </div>
                            <div className="flex-1 flex justify-end">
                                <Pagination
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Booking Modal */}
            <GlassmorphicModal
                isOpen={showCommunityForm}
                onClose={handleAddcommunityClick}
                title="Add Amenity Booking"
                size="lg"
                footer={bookingModalFooter}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {roleId !== 1003 && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                HOA Member Name <span className="text-red-500">*</span>
                            </label>
                            <select
                                name="amenityBookingDTO.bookedForClientId"
                                value={formData.amenityBookingDTO.bookedForClientId}
                                onChange={handleChange}
                                className={`w-full rounded-md border ${errors.bookedForClientId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                readOnly={roleId === 1003}
                            >
                                <option value="">Select Client</option>
                                {clients.map((client) => (
                                    <option key={client.clinetId} value={client.clinetId}>
                                        {client.firstName}
                                    </option>
                                ))}
                            </select>
                            {errors.bookedForClientId && (
                                <p className="text-red-500 text-sm mt-1">{errors.bookedForClientId}</p>
                            )}
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Select Amenity Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="amenityBookingDTO.amenityTypeId"
                            value={formData.amenityBookingDTO.amenityTypeId}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${errors.amenityTypeId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        >
                            <option value="">Select</option>
                            {amenityTypes.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                        {errors.amenityTypeId && (
                            <p className="text-red-500 text-sm mt-1">{errors.amenityTypeId}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Select Amenity <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="amenityBookingDTO.amenityId"
                            value={formData.amenityBookingDTO.amenityId}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${errors.amenityId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        >
                            <option value="">Select Amenity</option>
                            {amenities.map((amenity) => (
                                <option key={amenity.amenityId} value={amenity.amenityId}>
                                    {amenity.name}
                                </option>
                            ))}
                        </select>
                        {errors.amenityId && (
                            <p className="text-red-500 text-sm mt-1">{errors.amenityId}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Booked For Date <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <Calendar className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                                type="date"
                                name="amenityBookingDTO.bookingStart"
                                value={formData.amenityBookingDTO.bookingStart.split('T')[0]}
                                onChange={handleChange}
                                className={`pl-10 w-full rounded-md border ${errors.bookingStart ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                min={new Date().toISOString().split("T")[0]}
                            />
                        </div>
                        {errors.bookingStart && (
                            <p className="text-red-500 text-sm mt-1">{errors.bookingStart}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Booking Slot <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <Clock className="h-5 w-5 text-gray-400" />
                            </div>
                            <select
                                name="amenitySlots"
                                value={formData.amenitySlots}
                                onChange={handleChange}
                                className={`pl-10 w-full rounded-md border ${errors.amenitySlots ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                <option value="">Select Slot</option>
                                {slots.map((slot) => (
                                    <option
                                        key={slot.amenitySlotId}
                                        value={slot.amenitySlotId}
                                    >
                                        {slot.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {errors.amenitySlots && (
                            <p className="text-red-500 text-sm mt-1">{errors.amenitySlots}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
                        <input
                            type="number"
                            id="amount"
                            name="amenityBookingDTO.amount"
                            value={formData.amenityBookingDTO.amount}
                            readOnly
                            className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700"
                        />
                    </div>
                </div>
                <div className="text-sm text-red-500 mt-4">* indicates required field</div>
            </GlassmorphicModal>

            {/* View Booking Modal */}
            <GlassmorphicModal
                isOpen={viewCommunityForm}
                onClose={handleCancelClick}
                title="View Amenity Booking"
                size="lg"
                footer={viewModalFooter}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Booked For Date</label>
                        <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                            {viewData.bookingStart?.split('T')[0]}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Booking Date</label>
                        <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                            {viewData.bookingDate?.split('T')[0]}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Amenity Type</label>
                        <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                            {viewData.amenityTypeName}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Amenity</label>
                        <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                            {viewData.amenityName}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Amenity Slot</label>
                        <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                            {viewData.amenitySlotName}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
                        <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                            {viewData.amount}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Booking Status</label>
                        <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                            {viewData.amenityBookingStatusName}
                        </div>
                    </div>
                </div>
            </GlassmorphicModal>

            {/* Approval Modal */}
            <GlassmorphicModal
                isOpen={showApprovalModal}
                onClose={closeModal}
                title="Booking Approvals"
                size="sm"
                footer={approvalModalFooter}
            >
                <p className="text-gray-700 mb-6">Are you sure you want to update the status of this booking?</p>

                {selectedBookingId && (
                    <div className="flex flex-col gap-4">
                        {amenityBookings.map(
                            (booking) =>
                                booking.amenityBookingId === selectedBookingId && (
                                    <div
                                        key={booking.amenityBookingId}
                                        className="flex flex-wrap justify-center gap-2"
                                    >
                                        {booking.amenityBookingStatusId === 2 ? (
                                            <>
                                                {(roleId === 1001 || roleId === 1002) && (
                                                    <button
                                                        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 w-full"
                                                        onClick={() => handleUpdateStatus(3)}
                                                        disabled={loading}
                                                    >
                                                        Reject Booking
                                                    </button>
                                                )}
                                                {(roleId === 1003) && (
                                                    <button
                                                        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 w-full"
                                                        onClick={() => handleUpdateStatus(4)}
                                                        disabled={loading}
                                                    >
                                                        Cancel Booking
                                                    </button>
                                                )}
                                            </>
                                        ) : booking.amenityBookingStatusId === 1 ? (
                                            <>
                                                {(roleId === 1001 || roleId === 1002) && (
                                                    <>
                                                        <button
                                                            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 w-full"
                                                            onClick={() => handleUpdateStatus(2)}
                                                            disabled={loading}
                                                        >
                                                            Approve Booking
                                                        </button>
                                                        <button
                                                            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 w-full"
                                                            onClick={() => handleUpdateStatus(3)}
                                                            disabled={loading}
                                                        >
                                                            Reject Booking
                                                        </button>
                                                    </>
                                                )}
                                                {(roleId === 1003) && (
                                                    <button
                                                        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 w-full"
                                                        onClick={() => handleUpdateStatus(4)}
                                                        disabled={loading}
                                                    >
                                                        Cancel Booking
                                                    </button>
                                                )}
                                            </>
                                        ) : booking.amenityBookingStatusId === 3 ? (
                                            <>
                                            </>
                                        ) : booking.amenityBookingStatusId === 4 ? (
                                            <>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                )
                        )}
                    </div>
                )}
            </GlassmorphicModal>
        </div>
    );
};

export default AmenityBooking;